import(/* webpackMode: "eager" */ "/root/services/fash-creative/src/app/home/page.tsx")